/* @ngInject */
const myWagonDisplayScrapping = (
  $$sale,
  $$axletree,
  $$piece,
  $$sterile,
) => {
  return {
    restrict: 'E',
    scope: {
      myWagon: '=',
    },
    template: require('./myWagonDisplayScrapping.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.displayScrapping = false

      $scope.toggleDisplay = async () => {
        $scope.displayScrapping = !$scope.displayScrapping
        if ($scope.sale) return

        try {
          $scope.sale = await $$sale.request.getById($scope.myWagon.saleId)
        } catch (e) {
          return
        }

        const axletrees = $$axletree.request.getByWagon($scope.myWagon.id)
        const pieces = $$piece.request.getByWagon($scope.myWagon.id)
        const steriles = $$sterile.request.getByWagon($scope.myWagon.id)

        $scope.axletrees = await axletrees
        $scope.pieces = await pieces
        $scope.steriles = await steriles
      }

      $scope.goToSale = (_saleId) => {
        $$sale.go.details(_saleId)
      }
    },
    link: {
      pre: (scope, element, attrs) => { },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}

export default myWagonDisplayScrapping



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/directives/display/myWagonDisplayScrapping.js